var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 120,
    height: 120,
    rx: 60,
    fill: "url(#paint0_linear_8090_55306)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0889 40.8603L74.2484 44.9134C74.2484 44.9134 76.6802 45.724 76.6802 48.0749V65.017C76.6802 65.017 76.6802 70.7725 70.1952 74.8256C70.1029 74.8839 69.9897 74.9555 69.8582 75.0388C67.7947 76.3448 61.2297 80.5 60.4677 80.5C59.9002 80.5 54.7933 77.8249 52.1993 76.4469C51.3076 76.0415 50.4159 75.4741 49.9295 75.0688C47.9029 73.4475 42.796 68.5838 43.3634 62.7472C43.4445 61.9366 43.4445 48.1559 43.4445 48.1559C43.4445 48.1559 43.4445 46.5347 45.8764 44.9134C46.5249 44.5081 58.0358 40.8603 58.0358 40.8603C58.0358 40.8603 59.6571 40.0497 62.0889 40.8603ZM54.9374 54.2942C54.6511 54.2942 54.3765 54.408 54.174 54.6106C53.9716 54.8133 53.8579 55.0882 53.8579 55.3748C53.8579 55.6614 53.9716 55.9363 54.174 56.139L58.8094 60.779L54.174 65.419C53.9773 65.6229 53.8685 65.8959 53.8709 66.1793C53.8734 66.4627 53.987 66.7338 54.1872 66.9342C54.3874 67.1346 54.6582 67.2482 54.9413 67.2507C55.2244 67.2532 55.4971 67.1442 55.7008 66.9473L60.3361 62.3073L64.9715 66.9473C65.1752 67.1442 65.4479 67.2532 65.731 67.2507C66.0141 67.2482 66.2849 67.1346 66.4851 66.9342C66.6853 66.7338 66.7989 66.4627 66.8013 66.1793C66.8038 65.8959 66.695 65.6229 66.4983 65.419L61.8629 60.779L66.4983 56.139C66.6014 56.0392 66.6837 55.92 66.7403 55.7881C66.7968 55.6562 66.8266 55.5144 66.8279 55.3709C66.8291 55.2274 66.8018 55.0851 66.7475 54.9522C66.6932 54.8194 66.613 54.6987 66.5117 54.5972C66.4103 54.4958 66.2897 54.4155 66.157 54.3612C66.0243 54.3068 65.8822 54.2795 65.7388 54.2807C65.5954 54.282 65.4537 54.3118 65.322 54.3684C65.1903 54.4251 65.0711 54.5074 64.9715 54.6106L60.3361 59.2507L55.7008 54.6106C55.4983 54.408 55.2237 54.2942 54.9374 54.2942Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8090_55306",
    x1: 120,
    y1: 69.25,
    x2: 7.5,
    y2: 71.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C81E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02424"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidIcon);
export default __webpack_public_path__ + "static/media/invalid-icon.f55a07fb274541c2a771973bb5028ef1.svg";
export { ForwardRef as ReactComponent };